import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { EditTestInfoCoverData } from '@shared/interfaces/edit-test-info-cover-dialog';

@Component({
  selector: 'app-edit-test-info-dialog',
  templateUrl: './edit-test-info-dialog.component.html',
  styleUrls: ['./edit-test-info-dialog.component.scss'],
})
export class EditTestInfoDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<EditTestInfoDialogComponent>);
  private readonly fb = inject(FormBuilder);

  form: FormGroup;

  data: EditTestInfoCoverData = inject(MAT_DIALOG_DATA);

  ngOnInit(): void {
    this.form = this.fb.group({
      date: [this.data.date ?? false],
      sport: [this.data.sport ?? false],
      athlete: [this.data.athlete ?? false],
      coach: [this.data.coach ?? false],
      testDisplayId: [this.data.testDisplayId ?? false],
      testType: [this.data.testType ?? false],
    });
  }

  onUpdate(): void {
    this.dialogRef.close(this.form.value as EditTestInfoCoverData);
  }
}
